import { Components } from "@mui/material";
import { Theme } from "../types";

export const MuiButtonGroup = {
    styleOverrides: {
        root: { borderRadius: '12px', textTransform: 'none' },
    },
} satisfies Components<Theme>['MuiButtonGroup'];